var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticStyle: { height: "100%" },
      attrs: { "data-title": "新手引导" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex main-space-between",
          staticStyle: { margin: "46px 48px 0" }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex column main-center cross-center",
              on: {
                click: function($event) {
                  return _vm.onAboutClick(0)
                }
              }
            },
            [
              _c("img", {
                staticClass: "about_img",
                attrs: { src: require("../assets/about_cer.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "about_text" }, [_vm._v("关于班级")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex column main-center cross-center",
              on: {
                click: function($event) {
                  return _vm.onAboutClick(1)
                }
              }
            },
            [
              _c("img", {
                staticClass: "about_img",
                attrs: { src: require("../assets/about_class.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "about_text" }, [_vm._v("关于闯关")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex column main-center cross-center",
              on: {
                click: function($event) {
                  return _vm.onAboutClick(2)
                }
              }
            },
            [
              _c("img", {
                staticClass: "about_img",
                attrs: { src: require("../assets/about_pass.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "about_text" }, [_vm._v("关于课程")])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex main-space-between",
          staticStyle: { margin: "27px 48px 0" }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex column main-center cross-center",
              on: {
                click: function($event) {
                  return _vm.onAboutClick(3)
                }
              }
            },
            [
              _c("img", {
                staticClass: "about_img",
                attrs: { src: require("../assets/about_book.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "about_text" }, [_vm._v("关于图书")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex column main-center cross-center",
              on: {
                click: function($event) {
                  return _vm.onAboutClick(4)
                }
              }
            },
            [
              _c("img", {
                staticClass: "about_img",
                attrs: { src: require("../assets/about_other.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "about_text" }, [_vm._v("关于会员")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex column main-center cross-center",
              on: {
                click: function($event) {
                  return _vm.onAboutClick(5)
                }
              }
            },
            [
              _c("img", {
                staticClass: "about_img",
                attrs: { src: require("../assets/about_other.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "about_text" }, [_vm._v("其他问题")])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "flex main-center cross-center",
        staticStyle: { margin: "20px 18px 0 18px" }
      },
      [
        _c(
          "a",
          {
            attrs: { href: "https://mp.weixin.qq.com/s/OZXf7uN5aX3HCVG_w5QxXA" }
          },
          [
            _c("img", {
              staticClass: "noviceGuide",
              attrs: { src: require("../assets/novice_guide_student_bg.png") }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "flex main-center cross-center",
        staticStyle: { width: "100%", "margin-top": "70px" }
      },
      [
        _c("img", {
          staticClass: "noviceGuideQuestions",
          attrs: { src: require("../assets/noviceGuide_questions.png") }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-244083f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244083f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoviceGuideStudent.vue
// module id = null
// module chunks = 